module.exports = __webpack_public_path__ + "img/PhiNguyen.c59ee0a6.jpeg";